document.addEventListener('DOMContentLoaded', function () {
  const heroSlider = document.querySelector('#hero-slider .swiper');
  if (heroSlider) {
    const slideCount = heroSlider.querySelectorAll('.swiper-slide').length;
    new Swiper(heroSlider, {
      loop: slideCount > 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: 'fade', // フェード切替
      fadeEffect: { crossFade: true },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
});
